<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  icon: { type: String, default: 'i-lucide-link' },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  buttonLabel: { type: String, default: '' },
  buttonIcon: { type: String, default: 'i-lucide-link' },
});

const emit = defineEmits(['action']);
</script>

<template>
  <div
    class="flex flex-col items-center justify-center py-12 text-center"
  >
    <div
      class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800"
    >
      <slot name="icon">
        <Icon :icon="icon" class="h-8 w-8 text-slate-400" />
      </slot>
    </div>
    <h3 class="mb-2 text-lg font-medium text-slate-900 dark:text-slate-100">
      {{ title }}
    </h3>
    <p
      v-if="description"
      class="mb-6 max-w-md text-slate-600 dark:text-slate-400"
    >
      {{ description }}
    </p>
    <slot name="action">
      <Button
        v-if="buttonLabel"
        :label="buttonLabel"
        :icon="buttonIcon"
        @click="emit('action')"
      />
    </slot>
  </div>
</template>
